// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.endpoint-method-path {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 16px;
  overflow: hidden;
}

.endpoint-method-path-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  overflow: hidden;
  width: 100%;
  min-width: 0;
}

.endpoint-method-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  line-height: 20px;
  flex-shrink: 0;
}

.endpoint-url-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
  cursor: pointer;
}

.endpoint-url-part {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.88);
  line-height: 22px;
  white-space: nowrap;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.endpoint-path-separator {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  margin: 0 4px;
  flex-shrink: 0;
}

.endpoint-path-text {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.88);
  line-height: 22px;
}

.endpoint-domain-tag {
  display: inline-flex;
  align-items: center;
  height: 18px;
  line-height: 16px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/EndPointSection/components/EndpointMethodPath/EndpointMethodPath.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".endpoint-method-path {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #fafafa;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n  margin-top: 16px;\n  overflow: hidden;\n}\n\n.endpoint-method-path-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  width: 100%;\n  min-width: 0;\n}\n\n.endpoint-method-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  line-height: 20px;\n  flex-shrink: 0;\n}\n\n.endpoint-url-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  flex: 1;\n  cursor: pointer;\n}\n\n.endpoint-url-part {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.88);\n  line-height: 22px;\n  white-space: nowrap;\n  flex-shrink: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.endpoint-path-separator {\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.45);\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n.endpoint-path-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.88);\n  line-height: 22px;\n}\n\n.endpoint-domain-tag {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  line-height: 16px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
